import { render } from "./dashboard-template.vue?vue&type=template&id=459fbce6"
import script from "./dashboard-template.vue?vue&type=script&lang=js"
export * from "./dashboard-template.vue?vue&type=script&lang=js"

import "./dashboard-template.vue?vue&type=style&index=0&id=459fbce6&lang=css"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__